<template>
  <div class="count-wrap">
    <div class="name"><i class="iconfont icon-shandian"></i>限时折扣</div>
    <div class="flex">
      <span>剩余</span>
      <span class="day" v-if="i > 24*60*60">{{i|div(24*60*60)}}天</span>
      <span class="t">{{i|mod(24*60*60)|div(60*60)|f}}</span> <b>:</b>
      <span class="t">{{i|mod(60*60)|div(60)|f}}</span> <b>:</b>
      <span class="t">{{i|mod(60)|f}}</span>
      <span>恢复原价</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    end: {
      type: Number,
      default: 0
    }
  },
  filters: {
    f(v) {
      return v < 10 ? '0' + v : v
    },
    mod(i, n) {
      return parseInt(i % n)
    },
    div(i, n) {
      return parseInt(i / n)
    }
  },
  data() {
    return {
      i: 0,
      timer: null
    }
  },
  created() {
    const f = () => {
      const now = parseInt((new Date()).getTime() / 1000)
      if (this.end - now < 0) {
        clearInterval(this.timer)
        this.timer = null
        this.i = 0
      } else {
        this.i = this.end - now
      }
    }
    f()
    this.timer = setInterval(f, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .count-wrap
    background $color-theme
    height size(70)
    display flex
    padding 0 size(30)
    align-items center
    color #fff
    text-align right
  .name
    text-align left
    width size(250)
    font-size size(30)
    font-weight 700
    position relative
    left -5px
  .flex
    flex 1
    font-size size(26)
    color #ffe4ab
    b
      color #fff
  .t
    display inline-block
    background #fff
    color $color-theme
    width 18px
    height 18px
    line-height 18px
    border-radius 4px
    text-align center
    font-size 12px
</style>


// WEBPACK FOOTER //
// src/components/base/ui/free-countdown.vue